import {
  CookieCollection,
  getUrlParameter,
  modalalert,
  updateheaderCount,
  updateHeaderDates,
  updateHeaderPrice,
  updateRoomNumber
} from './script';
import * as _ from 'lodash';
import * as log from 'loglevel';
import qs from 'qs';

// @ts-ignore
import moment from 'moment';
import { Pax, ProductSearch, Dates } from './models';
import { access } from 'fs';
import { debug } from 'util';
import { stubString } from 'lodash';

const WIDGET_ROOMS = 1;
const WIDGET_MAX_ADULTS = 4;
const dateFormat = 'YYYY-MM-DD';

var promoCode = String($('#PromoCode').val());

if (typeof promoCode === 'undefined')
{
  promoCode = "";
}

CookieCollection.PromoCode.set({ code: promoCode});
console.log('PromoCode: ', promoCode);

// var giftVoucher = String($('#GiftVoucher').val());

// if (typeof giftVoucher === 'undefined')
// {
//   giftVoucher = "";
// }

// console.log('GiftVoucher: ', giftVoucher);
// CookieCollection.GiftVoucher.set({ code: giftVoucher, value: 0 });


const AccommodationModuleFactory = () => {
  const BUTTON_CONTINUE_SELECTOR = 'a#GetAvailability';
  const ROOM_HOLDER_SELECTOR = 'div#roomholder';
  // const SELECT_ADULT_SELECTOR = 'select.adultSelect';
  // const SELECT_CHILD_SELECTOR = 'select.childSelect';
  const SELECT_ADULT_SELECTOR = 'input.adultSelect';
  const SELECT_CHILD_SELECTOR = 'input.childSelect';
  const BUTTON_ADD_ROOM_SELECTOR = '.btn.btn-outline-green.btnAddRoom';
  const ROOM_WRAPPER_SELECTOR = '.roomwrapper';

  /**
   * Initialise initial display logic for accommodation page
   */
  function updateDatesInHeader() {   
    if ($('#checkin').val() != '')
    {
      const checkIn = moment($('#checkin').val(), dateFormat);
      $('.checkindatedisplay').text(checkIn.format('DD MMM'));  
    }
    if ($('#checkout').val() != '')  
    {
      const checkOut = moment($('#checkout').val(), dateFormat);
      $('.checkoutdatedisplay').text(checkOut.format('DD MMM'));  
    }
    if (($('#checkin').val() != '') && ($('#checkout').val() != ''))  
    {
      const checkIn = moment($('#checkin').val(), dateFormat);
      const checkOut = moment($('#checkout').val(), dateFormat);
      const dates: string[] = [];
      dates.push(checkIn.format('DD MMM'));
      dates.push(checkOut.format('DD MMM'));
      dates.push(checkIn.format('DD MMM YYYY'));
      dates.push(checkOut.format('DD MMM YYYY'));
      CookieCollection.DatesDisplay.set({ dates: dates });
  
    }
  }


  function init() {
    const rooms = Number(getUrlParameter('r')); // for
    const adults = Number(getUrlParameter('a')); // the
    const children = Number(getUrlParameter('c')); // widget

    const checkinDate = getUrlParameter('k');
    const nights = Number(getUrlParameter('n'));
    var flexible = getUrlParameter('f');
    if (!flexible)
    {
      flexible = '0';
    }

    //display error if invalid gift voucher
    const error = getUrlParameter('error') as string | undefined;
    if (error) {
    // $('.createbookingwrap').hide();
      modalalert(error.replace(/\+/g, ' '), 'error', false);
    }

    function applyChangeEventHandlerToDatePickerElements() {
      const $checkIn = $('#checkin');
      const $checkOut = $('#checkout');

      $checkIn.on('blur', (e) => {
        validateDate();
      });
      $checkOut.on('blur', (e) => {
        validateDate();
      });
      $checkIn.on('change', (e) => {
        var checkInVal = moment($checkIn.val(), dateFormat);
        if ($checkIn.val() != ''){
          var checkOutVal=checkInVal.add(1,'days');
          $checkOut.val(checkOutVal.format(dateFormat));  
        }
        updateDatesInHeader();
      });
      $checkOut.on('change', (e) => {
        updateDatesInHeader();
      });
    }
    
    function applyChangeEventHandlerToChildAgeSelectElements() {
      log.debug('applyChangeEventHandlerToChildAgeSelectElements');

      const $childAgeSelect = $(ROOM_HOLDER_SELECTOR).find(
        '   select'
        // '.childrow .child .input-group input'
      );

      $childAgeSelect.off('change');

      $childAgeSelect.on('change', (e) => {
        const $target = $(e.target);

        // return if it is disabled
        if ($target.parent('child').hasClass('d-none')) {
          return;
        }
        console.log("A");
        validate();
      });

      $('.btn-decrement').on('click', (e) => {
        const $target = $(e.target);

        // return if it is disabled
        if ($target.parent('child').hasClass('d-none')) {
          return;
        }
        console.log("B");

        //validate();
      });
      $('.btn-increment').on('click', (e) => {
        const $target = $(e.target);

        // return if it is disabled
        if ($target.parent('child').hasClass('d-none')) {
          return;
        }
        console.log("C");
        //validate();
      });
    }


    const addRoom = () => {
      const roomwrap = $('#roomholder .roomwrapper:last-child');

      const maxrooms = $(roomwrap).data('maxcount');
      let currentCount = $(roomwrap).data('roomcount');
      // console.log(maxrooms)
      currentCount = currentCount + 1;
      // console.log(currentCount)
      const $roomwrapper = $('.roomwrapper');
      if (maxrooms === $roomwrapper.length) {
        modalalert(
          'There are no more rooms available to select',
          'error',
          false
        );
      } else {
        $('#roomholder').append(
          '<div class="col-12 roomwrapper" data-roomcount="' +
            currentCount +
            '" data-maxcount="' +
            maxrooms +
            '"></div>'
        );
        $('#roomholder > div:last-child').html($(roomwrap).html());
        $('#roomholder > div:last-child .input-group').remove();
        $('#roomholder > div:last-child .childrow .child').addClass('d-none');
        $('#roomholder > div:last-child .childrow').addClass('hide2');

        if (maxrooms === $roomwrapper.length) {
          $('#AddRoom').hide();
        }
        updateRoomNumber();
        updateheaderCount();
        
        $("#roomholder > div:last-child .form-control-number").inputSpinner();
      }

      applyChangeEventHandlerToChildAgeSelectElements();
      applyChangeEventHandlerToDatePickerElements();
    };   

    // var $promo = String($('#promo').val());
    // if (typeof $promo === 'undefined')
    // {
    //   $promo = "";
    // }

 




    
    if (
      rooms === WIDGET_ROOMS &&
      adults <= WIDGET_MAX_ADULTS 
      && children === 0
    ) {   
      
      const productSearch: ProductSearch = {
        branchId: Number($('#productId').val()),
        paxs: Array(...Array(adults)).map(() => ({ age: 18, room: 1, accessible: false })),
        promoCode: promoCode
      };

      console.log('ProductSearch', productSearch);

      CookieCollection.ProductSearch.set(productSearch);

      location.href = `./check-availability?${qs.stringify({
        k: checkinDate,
        n: nights,
        f: flexible,
        promoCode: promoCode
      })}`;
      return;
    }

    if (
      rooms === WIDGET_ROOMS &&
      adults <= WIDGET_MAX_ADULTS 
      && children >= 0
    ) {
      
      console.log('setting occupancy from widget');

      $('.roomwrapper[data-roomcount=1] .adultSelect').val(
        adults
      );
      $('.roomwrapper[data-roomcount=1] .childSelect').val(
        children
      );
      $('.roomwrapper[data-roomcount=1] .childSelect').change();
      updateheaderCount();

    }

    // check for existing product search
    const productSearch = CookieCollection.ProductSearch.get();
    const datePicker = CookieCollection.Dates.get();

    const existingPax =
      !productSearch || !productSearch.paxs ? false : productSearch.paxs;

    if (datePicker != null)
    {  
      if (datePicker.checkIn != null)
      { 
        $('#checkin').val(datePicker.checkIn);         
      }
      if (datePicker.checkOut != null)
      { 
        $('#checkout').val(datePicker.checkOut); 
      }
    }
    else if (checkinDate != null) // dates passed on QS
    {
      

      //var checkInVal = moment(checkinDate, dateFormat);
      var checkOutVal = moment(new Date(checkinDate), dateFormat).add(nights, 'days');
      //var checkIn = moment(checkInVal, dateFormat);
      //var checkOut = moment(checkOutVal, dateFormat);

      $('#checkin').val(checkinDate);
      $('#checkout').val(checkOutVal.format('YYYY-MM-DD'));

      //console.log('checkin: ', checkIn.toString());
      //console.log('checkout: ', checkOut);
      //console.log('nights', nights);
    }

    if (existingPax) {
      const roomWrap = $('#roomholder .roomwrapper:last-child');
      const maxrooms = $(roomWrap).data('maxcount');
      const currentCount = $(roomWrap).data('roomcount');

      // loop through 10 rooms and fill in details
      for (let x = 1; x < 10; x++) {
        let adultcount = 0;
        let childcount = 0;
        let accessible = false;
        const childAges: number[] = [];

        for (let y = 0; y < existingPax.length; y++) {
          if (x === existingPax[y].room) {
            // if age is 18
            if (existingPax[y].age === 18) {
              adultcount++;
            } else {
              childcount++;
              childAges.push(existingPax[y].age);
            }
            if (existingPax[y].accessible)
            {
              accessible = true;
            }
          }
        }

        // if there are adults in the room, fill in fields
        if (adultcount !== 0) {
          // if not the first room, add another room row
          if (x !== 1) {
            $('#roomholder').append(
              '<div class="col-12 roomwrapper" data-roomcount="' +
                x +
                '" data-maxcount="' +
                maxrooms +
                '"></div>'
            );
            $('#roomholder > div:last-child').html($(roomWrap).html());
            updateRoomNumber();
          }

          $('.roomwrapper[data-roomcount="' + x + '"] .adultSelect').val(adultcount);
          $('.roomwrapper[data-roomcount="' + x + '"] .childSelect').val(childcount);
          $('.roomwrapper[data-roomcount="' + x + '"] .accessible').prop('checked',accessible);

          if (childcount === 0) {
            // hide child age ui
            const $roomwrapper = $('.roomwrapper[data-roomcount="' + x + '"]');
            $roomwrapper.find('.childrow').addClass('hide2');

            // apply 'd-none' class to disable validation for hidden child select elements
            $roomwrapper
              .find('.childrow .row')
              .children()
              .addClass('d-none');
          } else {
            $('.roomwrapper[data-roomcount="' + x + '"]')
              .find('.childrow')
              .removeClass('hide2');
          }

          for (let a = 0; a < childAges.length; a++) {
            $('.roomwrapper[data-roomcount="' + x + '"]')
              .find('.childrow .child')
              .each(function() {
                const itemNumber = $(this).data('count');
                const itemcount = a + 1;
                if (itemNumber <= itemcount) {
                  $(this).removeClass('d-none');

                  if (itemNumber === itemcount) {
                    const age = childAges[a];
                    // console.log('age is: ' + age)
                    $(this)
                      .find('.form-control')
                      .val(age);
                  }
                } else {
                  $(this).addClass('d-none');
                }
              });
          }
        }

        updateheaderCount();
      }
    }

    $(BUTTON_ADD_ROOM_SELECTOR).on('click', (evt) => {
      log.debug('add room button clicked');
      addRoom();
    });

    applyChangeEventHandlerToChildAgeSelectElements();
    applyChangeEventHandlerToDatePickerElements();

    // For adult/child increment buttons
 
      // This button will increment the value
      $('[data-quantity="plus"]').click(function(e){
          // Stop acting like a button
          e.preventDefault();
          // Get the field name
          var fieldName = $(this).attr('data-field');
          // Get its current value
          var currentVal = parseInt($('input[name='+fieldName+']').val() as string);
          // If is not undefined
          if (!isNaN(currentVal)) {
              // Increment
              $('input[name='+fieldName+']').val(currentVal + 1);
          } else {
              // Otherwise put a 0 there
              $('input[name='+fieldName+']').val(0);
          }
      });
      // This button will decrement the value till 0
      $('[data-quantity="minus"]').click(function(e) {
          // Stop acting like a button
          e.preventDefault();
          // Get the field name
          var fieldName = $(this).attr('data-field');
          // Get its current value
          var currentVal = parseInt($('input[name='+fieldName+']').val() as string);
          // If it isn't undefined or its greater than 0
          if (!isNaN(currentVal) && currentVal > 0) {
              // Decrement one
              $('input[name='+fieldName+']').val(currentVal - 1);
          } else {
              // Otherwise put a 0 there
              $('input[name='+fieldName+']').val(0);
          }
      });
  
  
    validate();

    // For widget if rooms > 1
    if (rooms && rooms > 1 && rooms <= 4) {
      for (let i = 0; i < rooms - 1; i += 1) {
        addRoom();
        log.debug('auto-adding room');
      }
    }

    updateRoomNumber();
    updateheaderCount();
  }

  /**
   * @returns {(Pax[]|undefined)}
   */
  function getPaxs() {
    const paxs: Pax[] = [];
    let error = false;
    const $roomWrapper = $(ROOM_WRAPPER_SELECTOR);
    $roomWrapper.each((index, element) => {
      const thisRoomCount = index + 1;
      const $element = $(element);
      const adultCountStr = $element.find('.adultSelect').val() as string;
      const accessible = $element.find('.accessible:checked').length > 0 ? true : false;

      console.error('room', thisRoomCount, accessible);

      if (!adultCountStr) {
        console.error('.adultSelect should not be null');
        return undefined;
      }
      const adultCount = parseInt(adultCountStr);

      if (adultCount == 0)
      {
        const minAdultErrorMessage = String($('#errorZeroAdult').val());
        modalalert(minAdultErrorMessage, 'error', false);
        error = true;
        return undefined;
      }

      const maxAStr = String($('#maxA').val());
      const maxA = parseInt(maxAStr);

      if (adultCount > maxA)
      {
        const maxAdultErrorMessage = String($('#errorMaxAdultExceeded').val());
        modalalert(maxAdultErrorMessage, 'error', false);
        error = true;
        return undefined;
      }

      const childCountStr = $element.find('.childSelect').val() as string;
      const childCount = parseInt(childCountStr);
      const maxCStr = String($('#maxC').val());
      const maxC = parseInt(maxCStr);

      if (childCount > maxC)
      {
        const maxChildErrorMessage = String($('#errorMaxChildExceeded').val());
        modalalert(maxChildErrorMessage, 'error', false);
        error = true;
        return undefined;
      }

      // loop through adult count, add to pax array
      for (let s = 0; s < adultCount; s++) {
        const thisPax: Pax = {
          age: 18,
          room: thisRoomCount,
          accessible: accessible
        };
        paxs.push(thisPax);
      }

      //get child error message
      const childErrorMessage = String($('#invalidChildError').val());
      const childMinAge = String($('#childMinAge').val());
      const childMaxAge = String($('#childMaxAge').val());
      // loop through child ages
      $element
      //.find('.childrow .child:not(.d-none) .input-group input')
      .find('.childrow .child:not(.d-none) select')

        .each((childIndex, childElement) => {
          const $childElement = $(childElement);
          const age = $childElement.val() as string | undefined;
          // log.debug(age);
          // log.debug(parseInt(childMinAge));
          // log.debug(parseInt(childMaxAge));
          if (!age) {
            $childElement.addClass('invalid');
            error = true;
          } else if (parseInt(age) < parseInt(childMinAge) || parseInt(age) > parseInt(childMaxAge)) {
            modalalert(childErrorMessage, 'error', false);
            error = true;
          }
          else 
          {
            $childElement.removeClass('invalid');
            console.log('child age passed validation');
            const thisPax: Pax = {
              age: parseInt(age),
              room: thisRoomCount,
              accessible: accessible
            };
            paxs.push(thisPax);
          }
        });
    });

    if (error) {
      return undefined;
    } else {
      return paxs;
    }
  }

  /**
   * validate form
   */
  function validateDate() {
    const $buttonContinue = $(BUTTON_CONTINUE_SELECTOR);
    const $checkIn = $('#checkin');
    const $checkOut = $('#checkout');
    var checkInVal = moment($checkIn.val(), dateFormat);
    if ($checkIn.val() != '')
    {
      if ($checkIn.attr('min')>'') 
      {
        var minDate= moment($checkIn.attr('min'), dateFormat);

        if (checkInVal<minDate) 
        {
          // alert(checkInVal + '-' + minDate)
          modalalert('Your check-in date must be on or after ' + $checkIn.attr('min'), 'error', true);
          $checkIn.val(''); 
          $checkOut.val(''); 
          return false;
        }
      }
      if ($checkOut.val() != '')
      { 
        var checkOutVal = moment($checkOut.val(), dateFormat);
// alert(checkOutVal + ' - ' + checkInVal)
        if (checkOutVal<checkInVal) 
        {
          // alert(checkInVal + '-' + minDate)
          modalalert('CheckOut date must ater checkIn date', 'error', true);
          $checkOut.val(''); 
          return false;
        }
      }
    }
    return true;
  }
  function validate() {
    console.log("validate called");
    updateDatesInHeader();
    var valid = !!getPaxs();
    const $buttonContinue = $(BUTTON_CONTINUE_SELECTOR);
    //valid=validateDate();
   


    if (valid) {
      $buttonContinue.removeClass('disabled');
    } else {
      $buttonContinue.addClass('disabled');
    }
  }

  return {
    init,
    validate,
    getPaxs
  };
};



export function Accommodation() {
  const accommodationModule = AccommodationModuleFactory();

  const $body = $('body');

  $body.on('change', '.adultSelect', function() {
    const countStr = $(this).val() as string | undefined;

    const parentRow = $(this).closest('.roomwrapper');

    const maxCount = $(parentRow).data('maxcount');

    const childCountStr = $(parentRow)
      .find('.childSelect')
      .val() as string | undefined;

    if (!countStr || !childCountStr) {
      console.error('count or childCount should not be undefined');
      return;
    }

    const childCount = parseInt(childCountStr);
    const count = parseInt(countStr);

    const thisRoomCount = childCount + count;

    if (maxCount < thisRoomCount) {
      const maxOccupancyError = String($('#errorCapacityExceeded').val());
      modalalert(maxOccupancyError, 'error', false);

      const maxAvailableCount = maxCount - childCount;
      // console.log(maxAvailableCount)
      $(parentRow)
        .find('.adultSelect')
        .val(maxAvailableCount);

      return false;
    }
        
    updateheaderCount();
    accommodationModule.validate();
  });

  $body.on('change', '.childSelect', function() {
    const countStr = $(this).val() as string | undefined;
    if (!countStr) {
      console.error('countStr should not be undefined');
      return;
    }
    const count = parseInt(countStr);
    let parentRow = $(this).closest('.roomwrapper');

    parentRow = $(this).closest('.roomwrapper');
    const maxCountStr = /** @type {(string|undefined)} */ $(parentRow).attr(
      'data-maxcount'
    );
    if (!maxCountStr) {
      console.error('maxCountStr should not be undefined');
      return;
    }
    const maxCount = parseInt(maxCountStr);

    const adultCountStr = $(parentRow)
      .find('.adultSelect')
      .val() as string;
    if (!adultCountStr) {
      console.error('adultCountStr should not be undefined');
      return;
    }
    const adultCount = parseInt(adultCountStr);
    console.log('adult: ', adultCount);
    console.log('child: ',count);

    const thisRoomCount = adultCount + count;
    // console.log(thisroomcount)
    if (maxCount < thisRoomCount) {
      modalalert(
        'This property fits up to ' +
          maxCount +
          ' people per room - please add another room.',
        'error',
        false
      );

      const maxAvailableCount = maxCount - adultCount;
      // console.log(maxavaiablecount)
      $(parentRow)
        .find('.childSelect')
        .val(maxAvailableCount);

      $(parentRow)
        .find('.childrow .child')
        .each(function() {
          const itemNumber = $(this).data('count');
          if (itemNumber <= maxAvailableCount) {
            $(this).removeClass('d-none');
          } else {
            $(this).addClass('d-none');
          }

          if (maxAvailableCount === 0) {
            $(parentRow)
              .find('.childrow')
              .addClass('hide2');
          } else {
            $(parentRow)
              .find('.childrow')
              .removeClass('hide2');
          }
        });

      return false;
    }

    $(parentRow)
      .find('.childrow .child')
      .each(function() {
        const itemNumber = $(this).data('count');
        if (itemNumber <= count) {
          $(this).removeClass('d-none');
        } else {
          $(this).addClass('d-none');
        }

        if (count === 0) {
          $(parentRow)
            .find('.childrow')
            .addClass('hide2');
        } else {
          $(parentRow)
            .find('.childrow')
            .removeClass('hide2');
        }
      });


    updateheaderCount();
    accommodationModule.validate();
  });

  // Select room page
  // Apply display logic on load
  accommodationModule.init();

  $body.on('click', '.removeRoom', function() {
    const parentRow = $(this).closest('.roomwrapper');
    
    if ($('.roomwrapper').length > 1) {
      $(parentRow).remove();
    }
  
    updateRoomNumber();
    updateheaderCount();
    const roomwrap = $('#roomholder .roomwrapper:last-child');
    const maxrooms = $(roomwrap).data('maxcount');
    if (maxrooms !== $('.roomwrapper').length) {
      $('#AddRoom').show();
    }
  });

  // accommodation check
  $('#GetAvailability').on('click', () => {
    const widgetRooms = getUrlParameter('rooms');
    const widgetEnd = getUrlParameter('enddate');
    const widgetFlex = getUrlParameter('flexible');
    const bID = $('#productId').val() as number;

    CookieCollection.SelectedRooms.remove();
    CookieCollection.Addons.remove();
    CookieCollection.PriceDisplay.remove();
    if (!($('#checkin').val() != '' && $('#checkout').val()!=''))
    {
      CookieCollection.DatesDisplay.remove();
      CookieCollection.Dates.remove();
      updateHeaderDates();
    }
    updateHeaderPrice();
    updateheaderCount();

    if (!bID) {
      log.error('bID should not be undefined');
      return;
    }

    var promoCode = String($('#PromoCode').val());

    if (typeof promoCode === 'undefined')
    {
      promoCode = "";
    }

    CookieCollection.PromoCode.set({ code: promoCode});
    console.log('PromoCode: ', promoCode);

    var stayVouchers = "";
    var initialVoucherCode = "";
    var invalidVouchers = false;

    $(".stay").each(function(){
      if (!$(this).hasClass("d-none") && $(this).find(':input').val() != '')
      {
        if (initialVoucherCode == "")
        {
          initialVoucherCode = $(this).find(':input').val().substr(0,1);
        }
        else if ( $(this).find(':input').val().substr(0,1) != initialVoucherCode)
        {
          invalidVouchers= true;
        }
        stayVouchers += $(this).find(':input').val();
        stayVouchers += "|";
      }
    });
    
    console.log("stayVouchers", stayVouchers);
    console.log("InvalidVouchers", invalidVouchers);

    CookieCollection.StayVoucher.set({codes: stayVouchers});
    
    var giftVoucher = String($('#GiftVoucher').val());

    if (typeof giftVoucher === 'undefined')
    {
      giftVoucher = "";
    }

    console.log('GiftVoucher: ', giftVoucher);
    CookieCollection.GiftVoucher.set({ code: giftVoucher, value: 0 }); 
    

    let productSearch: ProductSearch = {
      branchId: bID,
      promoCode: promoCode,
      paxs: []
    };

    const paxs = accommodationModule.getPaxs();
    

    if (paxs) {
      productSearch = { ...productSearch, paxs: paxs };
    }

    if (invalidVouchers)
    {
      modalalert('You cannot mix voucher types in a single transaction.  Please use either Stay -OR- Parent vouchers', 'error', false);
    }
    else if (!paxs) {
      modalalert('Please complete all required fields.', 'error', false);
    } else {
      CookieCollection.ProductSearch.set(productSearch);
      if ($('#checkin').val() != '' && $('#checkout').val()!='')
      {
        let dates: Dates = {
          checkIn: moment($('#checkin').val(), dateFormat).format(dateFormat),
          checkOut: moment($('#checkout').val(), dateFormat).format(dateFormat)
        }
        CookieCollection.Dates.set(dates);
      }

      CookieCollection.FlexibleDates.set($('#flexibledates').is(':checked') == true)

      if ($('#checkin').val()!='' && $('#checkout').val()!=''){
        if ($('#flexibledates').is(':checked')!=true)
        {
        window.location.href =
        './select-room?s=' +
        moment($('#checkin').val(), dateFormat).format(dateFormat) +
        '&e=' +
        moment($('#checkout').val(), dateFormat).format(dateFormat) +
        '&branch=' +
        bID +
        '&promoCode=' + 
        promoCode +
        '&rc=1&roommax=' +
        $('.roomwrapper').length ;
        }
        else
        {
          window.location.href = './check-availability?k=' + moment($('#checkin').val(), dateFormat).format(dateFormat);
        }
        return;
      }
      else{
        if ($('#salesStartDate').val()!=''){
          window.location.href = './check-availability?k=' + moment($('#salesStartDate').val(), dateFormat).format(dateFormat);
          return;
        }
      }

      var widgetStart = getUrlParameter('startdate');
      
      if (widgetStart || $('#checkout').val()!='') {
        if (widgetFlex === 'false') {
          window.location.href =
            './select-room?s=' +
            moment(widgetStart, dateFormat).format(dateFormat) +
            '&e=' +
            moment(widgetEnd, dateFormat).format(dateFormat) +
            '&branch=' +
            bID +
            '&rc=1&roommax=' +
            widgetRooms;
        } else {
          window.location.href = './check-availability?k=' + widgetStart;
        }
      } else {
        window.location.href = './check-availability';
      }
    }
  });
}
